function updateTicketNumbers(ticketDetails) {
    const allTickets = ticketDetails.querySelectorAll('[data-ticket-detail]');
    allTickets.forEach((ticket, index) => {
        const ticketNumber = index + 1;
        const ticketName = ticket.querySelector('.DG-main-event-listing__ticket-name');
        ticketName.textContent = `Ticket ${ticketNumber} - ${ticket.getAttribute('data-ticket-type')}`;
        ticket.setAttribute('data-ticket-detail', ticketNumber);
    });
}

function addTicketDetail(ticketType, ticketDetails, variantId) {
    const newDiv = document.createElement('div');
    newDiv.classList.add('DG-event-listing-card__detail-container')
    newDiv.setAttribute('data-ticket-detail', '')
    newDiv.setAttribute('data-ticket-variant', variantId)
    newDiv.setAttribute('data-ticket-type', ticketType)

    const phoneRegex = '[0-9+\\-\\(\\) ]+'

    let fieldsHTML = `
        <h3 class="DG-main-event-listing__ticket-name">
            Ticket - ${ticketType}
        </h3>
        <div class="DG-main-event-listing__half-field">
            <label for="firstName">First Name</label>
            <input type="text" id="firstName" name="First Name" required>
        </div>
        <div class="DG-main-event-listing__half-field">
            <label for="lastName">Last Name</label>
            <input type="text" id="lastName" name="Last Name" required>
        </div>
        <div class="DG-main-event-listing__half-field">
            <label for="email">Email Address</label>
            <input type="email" id="email" name="Email Address" required>
        </div>
        <div class="DG-main-event-listing__half-field">
            <label for="phone">Phone Number</label>
            <input type="tel" id="phone" name="Phone" pattern="${phoneRegex}" title="Please enter a valid phone number" required>
        </div>
    `;

    if (ticketType === 'Drummond Club Member') {
        fieldsHTML += `
        <div class="DG-main-event-listing__half-field">
            <label for="drummondClubMember">Drummond Club Member</label>
            <input type="number" id="drummondClubMember" name="Drummond Club Member" required>
        </div>
        <div class="DG-main-event-listing__half-field">
            <label for="golfLinkNumber">Golf Link Number</label>
            <input type="number" id="golfLinkNumber" name="Golf Link Number" required>
        </div>
        `;
    } else if (ticketType.includes('General Entry')) {
        fieldsHTML += `
        <div class="DG-main-event-listing__full-field">
            <label for="golfLinkNumber">Golf Link Number</label>
            <input type="number" id="golfLinkNumber" name="Golf Link Number" required>
        </div>
        `;
    }

    fieldsHTML += `
        <div class="DG-main-event-listing__full-field">
            <label for="comments">Comments</label>
            <textarea id="comments" name="Comments" rows="3" placeholder="Any additional comments, food allergies, etc."></textarea>
        </div>
    `;

    newDiv.innerHTML = fieldsHTML;
    ticketDetails.appendChild(newDiv);
}

function addTicketsToCart() {
    const ticketDetails = document.querySelectorAll('[data-ticket-detail]');

    let formData = {
        'items': []
    };

    ticketDetails.forEach(ticket => {
        const variantId = ticket.getAttribute('data-ticket-variant');
        const item = {
            'id': parseInt(variantId),
            'quantity': 1,
            'properties': {}
        };

        // Get all input fields within the ticket detail
        const fields = ticket.querySelectorAll('input, textarea');
        fields.forEach(field => {
            if (field.value) {
                item.properties[field.name] = field.value;
            }
        });

        formData.items.push(item);
    });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })

    return false;
}

function updateTotals () {
    const qtySelectors = document.querySelectorAll('[data-quantity-selector]');
    const totalPriceElement = document.querySelector('[data-total-price]');
    const totalItemsElement = document.querySelector('[data-total-items]');
    const addToCartButton = document.querySelector('[data-add-tickets]')

    let total = 0;
    let totalItems = 0;


    qtySelectors.forEach((selector) => {
      const quantity = parseInt(selector.value);
      const price = parseFloat(selector.getAttribute('data-variant-price'));

      if (quantity > 0) {
        total += quantity * price;
        totalItems += quantity;
      }
    });

    addToCartButton && (addToCartButton.disabled = !(totalItems > 0));

    let totalPrice = (total / 100).toFixed(2);
    let formattedTotalPrice = window.theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, totalPrice);
    totalPriceElement.textContent = formattedTotalPrice;
    totalItemsElement.textContent = totalItems > 0 ? ` (${totalItems})` : '';
}

const validateForm = () => {
    const form = document.querySelector('[data-product-form');
    if (!form) return;

    const isValid = form.checkValidity();
    form.reportValidity();

    if (!isValid) return;
    addTicketsToCart();
}

document.addEventListener('DOMContentLoaded', function() {
    const selectors = {
        qtySelectors: '[data-quantity-selector]',
        ticketDetails: '[data-ticket-details]',
        addToCartButton: '[data-add-tickets]'
    }

    const qtySelectors = document.querySelectorAll(selectors.qtySelectors);
    const ticketDetails = document.querySelector(selectors.ticketDetails);
    const addToCartButton = document.querySelector(selectors.addToCartButton);

    if(!addToCartButton) return

    addToCartButton.addEventListener('click', () => validateForm());

    if(!qtySelectors || !ticketDetails) return;

    for (let i = 0; i < qtySelectors.length; i++) {
        const selector = qtySelectors[i];

        selector.addEventListener('change', () => {
            let ticketType = selector.getAttribute('data-quantity-selector')
            let variantId = selector.getAttribute('data-variant-id')
            let selectedValue = Number(selector.value);

            // Get all existing ticket details
            const existingTickets = ticketDetails.querySelectorAll(`[data-ticket-type="${ticketType}"]`);
            const currentCount = existingTickets.length;

            // Add or remove tickets as needed
            if (selectedValue > currentCount) {
                // Add more tickets
                for (let index = currentCount; index < selectedValue; index++) {
                    addTicketDetail(ticketType, ticketDetails, variantId);
                }
            } else if (selectedValue < currentCount) {
                // Remove excess tickets
                for (let index = currentCount - 1; index >= selectedValue; index--) {
                    existingTickets[index].remove();
                }
            }

            // Update all ticket numbers
            updateTicketNumbers(ticketDetails);
            updateTotals();
        })
    }
});
